import React, { useEffect } from "react";
import Swal from "sweetalert2";
import { cancelPaymentLink } from "services/user/orderService";
import "./CancelPayment.scss";
import { useState } from "react";
import { PacmanLoader } from "react-spinners";

const CancelPayment = () => {
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchCancelPayment = async () => {
      const token = localStorage.getItem("token");
      const orderID = localStorage.getItem("orderID");

      if (token && orderID) {
        try {
          setIsLoading(true);
          const response = await cancelPaymentLink(token, orderID);
          console.log("Payment canceled successfully");

          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Thanh toán đã bị hủy",
              text: "Bạn sẽ được chuyển về trang chủ.",
              confirmButtonText: "Quay lại trang chủ",
              timer: 4000,
              showLoaderOnConfirm: true,
              customClass: {
                popup: "my-swal",
              },
              didClose: () => {
                window.location.href = "/";
              },
            });
          }
        } catch (err) {
          console.error("Error canceling payment:", err);
          Swal.fire({
            icon: "error",
            title: "Có lỗi xảy ra",
            text: "Không thể hủy thanh toán. Vui lòng thử lại.",
          });
        } finally {
          setIsLoading(false);
        }
      } else {
        console.log("Không tìm thấy thông tin cần thiết để hủy thanh toán.");

        // Informative alert when missing necessary data
        Swal.fire({
          icon: "warning",
          title: "Thông tin thiếu sót",
          text: "Không tìm thấy thông tin để hủy thanh toán.",
        });
      }
    };

    fetchCancelPayment();
  }, []);

  return (
    <div className="cancel-payment-container">
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CancelPayment;
